import React from 'react';
import Layout from "@layouts/TransitionLayout";

export default ({ element, props }) => {
    return <Layout {...props}>{element}</Layout>
}
